import React from 'react'
import { FilterButton } from './filter/Button'
import { FilterModal } from './filter/Modal'
import cloneDeep from 'clone-deep'

interface Props {
  initialFilter: TObjectAny
  filter: TObjectAny
  onChange: (filter: TObjectAny) => void
  children: (key: number, filter: TObjectAny, onUpdate: (filter: TObjectAny) => void) => React.ReactNode
}

export const Filter = ({ initialFilter, filter, onChange, children }: Props) => {
  const [key, setKey] = React.useState(0)
  const [show, setShow] = React.useState(false)
  const [nextFilter, setNextFilter] = React.useState({ ...filter })
  const count = Object.entries(filter).reduce((a, i) => i[1] ? a + 1 : a, 0)

  const onUpdate = React.useCallback((filter: TObjectAny) => {
    setNextFilter(filter)
  }, [])

  const onApply = React.useCallback(() => {
    const filter = { ...nextFilter }
    setKey(key => key + 1)
    setShow(false)
    onChange(filter)
  }, [nextFilter, onChange])

  const onCancel = React.useCallback(() => {
    setNextFilter({ ...filter })
    setKey(key => key + 1)
    setShow(false)
  }, [filter])

  const onReset = React.useCallback(() => {
    const filter = cloneDeep(initialFilter)
    setNextFilter(filter)
    setKey(key => key + 1)
    setShow(false)
    onChange(filter)
  }, [onChange, initialFilter])

  return (
    <>
      <FilterButton count={count} onClick={() => setShow(true)} onReset={onReset} />
      <FilterModal show={show} onApply={onApply} onClose={onCancel}>
        {children(key, filter, onUpdate)}
      </FilterModal>
    </>
  )
}
